export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_15.a9d52ba3.jpg";